// src/components/marketing/Navbar.jsx
import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/auth-context';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="fixed top-0 left-0 w-full bg-white flex justify-between items-center px-6 md:px-12 py-3.5 border-b border-gray-100 z-50">
      {/* Logo */}
      <div className="font-['Lexend_Deca'] text-2xl text-purple-600 font-light">
        L<span className="text-purple-800 font-semibold">M</span>
      </div>

      {/* Mobile Menu Toggle */}
<button
  className="md:hidden flex flex-col justify-between w-6 h-5 cursor-pointer"
  onClick={toggleMenu}
  aria-label="Toggle menu"
>
  <span
    className={`w-full h-0.5 bg-charcoal-800 rounded transition-all duration-300 ${
      isMenuOpen ? 'transform translate-y-1.5 rotate-45' : ''
    }`}
  ></span>
  <span
    className={`w-full h-0.5 bg-charcoal-800 rounded transition-all duration-300 ${
      isMenuOpen ? 'opacity-0' : ''
    }`}
  ></span>
  <span
    className={`w-full h-0.5 bg-charcoal-800 rounded transition-all duration-300 ${
      isMenuOpen ? 'transform -translate-y-1.5 -rotate-45' : ''
    }`}
  ></span>
</button>



      {/* Desktop Navigation Links */}
      <ul className="hidden md:flex list-none gap-6 m-0 p-0">
        <li>
          <Link
            to="/"
            className={`no-underline font-medium transition-colors duration-200 ${
              isActive('/') ? 'text-purple-600' : 'text-charcoal-800 hover:text-purple-600'
            }`}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/scholingen"
            className={`no-underline font-medium transition-colors duration-200 ${
              isActive('/scholingen') ? 'text-purple-600' : 'text-charcoal-800 hover:text-purple-600'
            }`}
          >
            Scholingen
          </Link>
        </li>
        <li>
          <Link
            to="/nieuwsbrief"
            className={`no-underline font-medium transition-colors duration-200 ${
              isActive('/nieuwsbrief') ? 'text-purple-600' : 'text-charcoal-800 hover:text-purple-600'
            }`}
          >
            Nieuwsbrief
          </Link>
        </li>
        <li>
          <Link
            to="/over-ons"
            className={`no-underline font-medium transition-colors duration-200 ${
              isActive('/over-ons') ? 'text-purple-600' : 'text-charcoal-800 hover:text-purple-600'
            }`}
          >
            Over ons
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            className={`no-underline font-medium transition-colors duration-200 ${
              isActive('/contact') ? 'text-purple-600' : 'text-charcoal-800 hover:text-purple-600'
            }`}
          >
            Contact
          </Link>
        </li>
      </ul>

      {/* Auth Buttons - Desktop */}
    <div className="hidden md:flex gap-4">
  {isAuthenticated ? (
    <>
      <Link
        to="/dashboard"
        className="px-4 py-2 rounded-lg no-underline font-semibold text-sm text-purple-800 border-2 border-purple-800 hover:bg-purple-50 hover:text-purple-900 transition-colors"
      >
        Dashboard
      </Link>
      <button
        onClick={handleLogout}
        className="px-4 py-2 rounded-lg font-semibold text-sm bg-purple-600 text-white hover:bg-purple-700 transition-colors"
      >
        Uitloggen
      </button>
    </>
  ) : (
    <>
      <Link
        to="/login"
        className="px-4 py-2 rounded-lg no-underline font-semibold text-sm text-purple-800 border-2 border-purple-800 hover:bg-purple-50 hover:text-purple-900 transition-colors"
      >
        Inloggen
      </Link>
      <Link
        to="/register"
        className="px-4 py-2 rounded-lg no-underline font-semibold text-sm bg-purple-600 text-white hover:bg-purple-700 transition-colors"
      >
        Aanmelden
      </Link>
    </>
  )}
</div>


      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-[60px] left-0 right-0 bg-white border-t border-gray-100 py-5 px-5 flex flex-col gap-4">
          <Link
            to="/"
            className={`no-underline font-medium ${
              isActive('/') ? 'text-purple-600' : 'text-charcoal-800'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/scholingen"
            className={`no-underline font-medium ${
              isActive('/scholingen') ? 'text-purple-600' : 'text-charcoal-800'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            Scholingen
          </Link>
          <Link
            to="/nieuwsbrief"
            className={`no-underline font-medium ${
              isActive('/nieuwsbrief') ? 'text-purple-600' : 'text-charcoal-800'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            Nieuwsbrief
          </Link>
          <Link
            to="/over-ons"
            className={`no-underline font-medium ${
              isActive('/over-ons') ? 'text-purple-600' : 'text-charcoal-800'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            Over ons
          </Link>
          <Link
            to="/contact"
            className={`no-underline font-medium ${
              isActive('/contact') ? 'text-purple-600' : 'text-charcoal-800'
            }`}
            onClick={() => setIsMenuOpen(false)}
          >
            Contact
          </Link>

          {/* Mobile Auth Buttons */}
          <div className="flex flex-col gap-2 mt-4 pt-4 border-t border-gray-100">
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  className="px-4 py-2 rounded-md text-center no-underline font-semibold text-sm text-purple-800 border border-purple-800"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Dashboard
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMenuOpen(false);
                  }}
                  className="px-4 py-2 rounded-md font-semibold text-sm bg-purple-500 text-white"
                >
                  Uitloggen
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 rounded-md text-center no-underline font-semibold text-sm text-purple-800 border border-purple-800"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Inloggen
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 rounded-md text-center no-underline font-semibold text-sm bg-purple-500 text-white"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Aanmelden
                </Link>
              </>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;